<div class="pulsecheckViewContainer">
    @if (isLoading) {
        <div class="pulsecheckViewContent_loadingContainer">
            <mat-spinner [diameter]="70" ></mat-spinner>
        </div>
    }

    @else if (isSubmissionCompletedSuccessfully) {
        <app-submission-success [frequencyText]="frequencyText"></app-submission-success>
    }

    @else{
        <div class="pulsecheckViewHeader">
          <h1>{{'pulseCheckView.header' | translate: {name: userDetailsRetrievedFromToken.firstName} }}</h1>
      </div>

        <div class="pulsecheckViewContent_submitSection" [class.disabled]="!userRespondedToAllQuestions">
            <div class="pulsecheckViewContent_submitInfo">
              <mat-icon class="pulsecheckViewContent_submitInfoIcon">groups</mat-icon>
              <div class="pulsecheckViewContent_submitInfoText">
                <h3>{{'pulseCheckView.submitHeader' | translate}}</h3>
                <p>{{'pulseCheckView.submitSubheader' | translate}}</p>
              </div>
            </div>
          
            <div class="pulsecheckViewContent_submitAction">
              <button mat-button [disabled]="!userRespondedToAllQuestions" (click)="onSubmit()">
                <mat-icon>send</mat-icon> 
                {{'pulseCheckView.submitButton' | translate}}
              </button>
            </div>
        </div>

        @if (userDetailsRetrievedFromToken.role === userRolesIntsance.HR || userDetailsRetrievedFromToken.role === userRolesIntsance.MANAGER) {
            <div class="pulsecheckViewContent_sectionContainer" [ngClass]="{'is-mobile-view': isMobileView}">
                <mat-icon class="pulsecheckViewContent_headerIcon">group</mat-icon>
                <h2>{{'pulseCheckView.managerialQuestionHeader' | translate}}</h2>
                <span>{{'pulseCheckView.managerialQuestionText' | translate : {frequency_text: frequencyText} }}</span>        
                <app-horizontal-scale-slider (valueChange)="onValueChange(pulsecheckViewInteractionTypeInstance.TEAM_LEAD_PROGRESS, $event)" class="pulsecheckViewContent_slider"></app-horizontal-scale-slider>
            </div>
        }


        <div class="pulsecheckViewContent_sectionContainer" [ngClass]="{'is-mobile-view': isMobileView}" #totalEnergyLevelSlider>
            <mat-icon class="pulsecheckViewContent_headerIcon">bolt</mat-icon>
            <h2>{{'pulseCheckView.totalEnergyQuestion' | translate}}</h2>
            <span>{{'pulseCheckView.totalEnergyQuestionText' | translate : {frequency_text: frequencyText} }}</span>        
            <app-horizontal-scale-slider class="pulsecheckViewContent_slider" (valueChange)="onValueChange(pulsecheckViewInteractionTypeInstance.TOTAL_ENERGY_LEVEL, $event)"></app-horizontal-scale-slider>
        </div>

        <div class="pulsecheckViewContent_sectionContainer" [ngClass]="{'is-mobile-view': isMobileView}">
            <mat-icon class="pulsecheckViewContent_headerIcon">tune</mat-icon>
            <div class="pulsecheckViewContent_sectionHheader">
                <h2>{{'pulseCheckView.driverExpression' | translate}}</h2>
                <span>{{'pulseCheckView.driverExpressionDescription' | translate : {frequency_text: frequencyText} }}</span>
            </div>
    
            <div class="pulsecheckView_slidersContainer" [ngClass]="{'is-mobile-view': isMobileView}">
                @for(motivation of userMotivations; track motivation.id){
                    <!-- <div class="pulsecheckViewContent"> -->
                    <app-driver-energy-slider 
                        [name]="motivation.name" 
                        [icon]="motivation.imageUrl" 
                        [baseColor]="motivation.color"
                        (valueChange)="onValueChange(motivation.id, $event)"
                    ></app-driver-energy-slider>
                <!-- </div> -->
                }
            </div>
        </div>
    
        <div class="pulsecheckViewContent_submitSection" [class.disabled]="!userRespondedToAllQuestions">
            <div class="pulsecheckViewContent_submitInfo">
              <mat-icon class="pulsecheckViewContent_submitInfoIcon">groups</mat-icon>
              <div class="pulsecheckViewContent_submitInfoText">
                <h3>{{'pulseCheckView.submitHeader' | translate}}</h3>
                <p>{{'pulseCheckView.submitSubheader' | translate}}</p>
              </div>
            </div>
          
            <div class="pulsecheckViewContent_submitAction">
              <button mat-button [disabled]="!userRespondedToAllQuestions" (click)="onSubmit()">
                <mat-icon>send</mat-icon> 
                {{'pulseCheckView.submitButton' | translate}}
              </button>
            </div>
        </div>
    }
</div>
